<input type="hidden" [formControl]="dynamicSelect" [formlyAttributes]="field" />

<div *ngIf="this.showBy != 'no'">
    <label class="filterLabelStyle" style="margin: 0 !important;">{{label||"No Label"}}</label>

    <!-- Selcted Dropdown -->
    <ng-select #sc class="ngSelection" style="font-size:13px" [multiple]="false" [dropdownPosition]="'bottom'"
        [clearable]="false" [items]="(opt?.options || [])" [placeholder]="this.placeholder" [(ngModel)]="this.selectedOption"
        [clearable]="false" [closeOnSelect]="false" [bindLabel]="this.labelProp" (open)="onOpen()" (close)="onClose()" [virtualScroll]="true">
        <!-- Sesrch Header -->
        <ng-template ng-header-tmp>
            <input class="searchFiler" type="text" (input)="sc.filter(onFilterTextBoxChanged($event))"
                placeholder="Search" />
        </ng-template>

        <!-- Dropdown lable -->
        <ng-option *ngFor="let option of (opt?.options || [])" [value]="option">
            {{ option[this.labelProp] }}
        </ng-option>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div class="form-check" style="display: flex;align-items: center;" [class.justify-content-between]="!isRootSqBadge">
                <div>
                    <input class="form-check-input" id="item-{{ index }}" style="opacity: 1 !important;" type="checkbox"
                        [disabled]="selectedOption" [ngModel]="item$.selected" [value]="item">
                    <label [matTooltip]="item[this.toolTipKey]" [matTooltipPosition]="'above'"
                        matTooltipClass="example-tooltip-single"
                        style="cursor: pointer;opacity: 1 !important;color: #000;font-family: 'Poppins' !important;"
                        class="form-check-label" for="flexCheckDefault">
                        <span>{{ item[this.labelProp] }}&#8288;<span *ngIf="isRootSqBadge && decomm_flag && item[decommReplaceName] == 'Y'"
                            class="du-comm-flag-badge-btn" [matTooltip]="decommTooltip || 'Decommissioned'"
                            [style.background]="decommColor + '33' || '#f2d3cd'"
                            [style.border-color]="decommColor || '#c04a36'"
                            [style.color]="decommColor || '#c04a36'"
                            >{{decommlabel}}</span></span>
                    </label>
                </div>
                <span *ngIf="!isRootSqBadge && decomm_flag && item[decommReplaceName] == 'Y'">
                    <span class="du-decomm-btn" [matTooltip]="decommTooltip || 'Decommissioned'"
                    [style.background]="decommColor + '33' || '#f2d3cd'"
                    [style.border-color]="decommColor || '#c04a36'"
                    [style.color]="decommColor || '#c04a36'"
                    >{{decommlabel}}</span>
                </span>
            </div>
        </ng-template>

        <!-- Apply Button -->
        <ng-template ng-footer-tmp>
            <div class="d-flex align-items-center py-2" style="gap: 10px">
                <button 
                    matTooltip="Include"
                    class="btn include du-single-select-btn" (click)="applyFilter(sc)"
                    >
                        <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="7" width="8" height="3" fill="#1363DF" />
                            <rect x="7" y="12" width="8" height="3" fill="#1363DF" />
                            <path
                                d="M6.15338 6.46002L-5.28031e-07 6.46003L-3.46196e-07 8.53998L6.15338 8.53998L3.76241 11.0228L5.18496 12.5L10 7.5L5.18496 2.5L3.76241 3.9772L6.15338 6.46002Z"
                                fill="#1363DF" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M6.62947 4L9.5185 7H5V6.46003L6.15338 6.46002L5 5.26233V4H6.62947ZM8.01778 4H13V7H10.8663C10.8265 6.93118 10.7778 6.86608 10.7203 6.80634L8.01778 4Z"
                                fill="#1363DF" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M9.5185 8L6.62947 11H6V8.69925L6.15338 8.53998H6V8H9.5185ZM10.8663 8H14V11H8.01778L10.7203 8.19366C10.7778 8.13392 10.8265 8.06882 10.8663 8Z"
                                fill="#1363DF" />
                        </svg>
                </button>
            </div>

            <!-- <button (click)="applyFilter(sc)" class="btn btn-sm btn-secondary buttonApply">Apply</button> -->
        </ng-template>
    </ng-select>
    <hr>
</div>